module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(4)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('p', {}, [_c('b', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("Plans & Pricing")]), _c('br'), _vm._v("\n                        Sign up for free and only start paying after onboarding the first 30 LogBox patients")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "price-plans-table-header white"
  }, [_c('tr', [_c('th', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("LogBox Core")])]), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_c('h4', [_vm._v("LogBox Premium")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', {
    staticClass: "price-plans-table-footer white"
  }, [_c('tr'), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('h4', [_vm._v("R250/ month")])]), _vm._v(" "), _c('td', [_c('h4', [_vm._v("R970/ month")])])]), _vm._v(" "), _c('tr', {
    staticClass: "align-center"
  }, [_c('td'), _vm._v(" "), _c('td', [_c('p', [_vm._v("R2500 once-off practice\n                                                "), _c('br'), _vm._v(" configuration and training fee")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("R2500 once-off practice\n                                                "), _c('br'), _vm._v(" configuration and training fee")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-pp-discount card-body"
  }, [_vm._v("\n                                   Academic Units (State sector) qualify for 50% Discount\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-pp-discount card-body"
  }, [_vm._v("\n                                    Allied health (Single practice) qualify for 20% Discount\n                                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-landing"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "price-plans-table table table-hover",
    attrs: {
      "id": "pricePlansTable"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.plans), function(feature, index) {
    return _c('tr', {
      key: index,
      staticClass: "price-plans-table-rows"
    }, [_c('td', [_vm._v(_vm._s(feature.name))]), _vm._v(" "), _c('td', [(feature.isCoreActive) ? _c('i', {
      staticClass: "price-plan-icons fas fa-check fa-lg"
    }) : _vm._e()]), _vm._v(" "), _c('td', [(feature.isPremiumActive) ? _c('i', {
      staticClass: "price-plan-icons fas fa-check fa-lg"
    }) : _vm._e()])])
  }), 0), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn practice-pp-signup-btn",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("SIGN UP NOW")])], 1)])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98c731f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/PricePlans.vue
// module id = 673
// module chunks = 5